import React, { useContext, useState } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext';
import logo from '../../images/csg-logo-blue.png';
import Dashboard from './Dashboard';
import SystemRegistration from './SystemRegistration';
import PaymentOverview from './PaymentOverview';
import Account from './Account';
import './App.scss';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import SetupTwoFactorAuth from '../../components/TwoFactorAuth/SetupTwoFactorAuth';
import Invoices from './Invoices';
import MeterRead from './MeterRead';

export default function App() {
    const {
        user,
        auth,
        sessionSettings,
        systems,
        system,
        onLogout,
        onChangeSystem
    } = useContext(AuthContext);

    const shouldShowMeterReadForm = (system.resource.online_monitoring_access_type?.toLowerCase() === 'self' ||
        (system.resource.online_monitoring_access_type?.toLowerCase() === 'other' && system.resource.online_monitoring_self_report)
    );

    const [profileActionsOpen, setProfileActionsOpen] = useState(false);
    const [settings] = useState(sessionSettings);

    const userOptionsLabel = 'Hello, ' + (user.first_name || ' there.');

    if (!auth.two_factor_auth_enabled) {
        return <SetupTwoFactorAuth />;
    }

    const nav = [
        { path: '/', label: 'System Registration', icon: 'leaderboard', component: SystemRegistration, exact: true },
        { path: '/dashboard', label: 'Dashboard', icon: 'dashboard', component: Dashboard, exact: true },
        { path: '/payment-history', label: 'Payments', icon: 'credit_card', component: PaymentOverview, exact: true },
        { path: '/invoices', label: 'Invoices', icon: 'receipt_long', component: Invoices, exact: true },
        { path: '/account', label: 'My Account', icon: 'person', component: Account, exact: false },
    ];

    if(shouldShowMeterReadForm) {
        nav.splice(2, 0, {path: '/meter-read-reporting', label: 'Meter Read Reporting', icon: 'receipt_long', component: MeterRead, exact: true})
    }

    return ( 
        <>
            <div className='app-container' style={! auth.two_factor_auth_enabled ? { filter: 'blur(2px)'} : {}} onClick={()=>{
                //  Close everything
                setProfileActionsOpen(false);
            }}>
                {
                    settings.menu_closed ? null :
                        <div className='app-navigation'>
                            <div className='app-navigation--header'>
                                <img src={logo} alt='logo'/>
                            </div>
                            <nav className='app-main-nav-container'>
                                <ul className='app-main-nav'>
                                    {nav.map((navItem, k)=>{
                                        return (
                                            <li className='app-main-nav--item--container' key={k}>
                                                <NavLink exact={navItem.exact||false} to={navItem.path} className='app-main-nav--item'>
                                                    <span className='app-main-nav--item--icon'>
                                                        <span className="material-symbols-outlined material-icons">{navItem.icon}</span>
                                                    </span>
                                                    <span className='app-main-nav--item--label'>{navItem.label}</span>
                                                </NavLink>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </nav>
                        </div>
                }
                <div className='app-content-container'>
                    <div className='app-header'>
                        <div className='app-header-left'>
                            
                        </div>
                        
                        <div className='app-header-right' onClick={(e)=>e.stopPropagation()}>
                            <div className='app-header-alerts'>
                                <div className='app-header-alerts-button'>
                                    <span>
                                        <i className="icofont-clock-time"></i>
                                    </span>
                                </div>
                            </div>
                            <div className='app-header-profile'>
                                <div className={'app-header-profile-name ' + (profileActionsOpen ? 'active' : '')} onClick={()=>setProfileActionsOpen(!profileActionsOpen)}>
                                    <span>{userOptionsLabel}</span> <span className="material-symbols-outlined material-icons">expand_more</span>
                                </div>
                                {
                                    profileActionsOpen ? 
                                        <div className='app-header--profile-actions'>
                                            
                                            <div className='app-header--profile-actions-panel'>
                                                <h4 style={{ padding: 10 }}>systems</h4>
                                                <ul>
                                                    {(systems||[]).map((p)=>{
                                                        return <li key={p.id}>
                                                                    {
                                                                        p.id === system.id ?
                                                                            <span style={{ display: 'flex', flexDirection: 'row', alignItems:'center', gap: 10}}>
                                                                                <div>
                                                                                    <div style={{ display: 'block', width: 10, height: 10, borderRadius: '50%', background: '#409F1D' }}></div>
                                                                                </div>
                                                                                
                                                                                {p.resource.name}
                                                                            </span>
                                                                        :
                                                                            <>
                                                                                {/* eslint-disable-next-line */}
                                                                                <a href="#"
                                                                                    style={{ display: 'flex', flexDirection: 'row', alignItems:'center', gap: 10}}
                                                                                    onClick={(e)=>{
                                                                                        e.preventDefault();
                                                                                        onChangeSystem(p);
                                                                                    }}
                                                                                >
                                                                                    <div>
                                                                                        <div style={{ display: 'block', width: 10, height: 10, borderRadius: '50%', background: 'transparent', border: 'solid #ccc 1px' }}></div>
                                                                                    </div>
                                                                                    {p.resource.name}
                                                                                </a>
                                                                            </>
                                                                    }
                                                                </li>
                                                    })}
                                                </ul>
                                            </div>
                                            <div className='app-header--profile-actions-panel'>
                                                <h4 style={{ padding: 10 }}>Account Actions</h4>
                                                <ul>
                                                    <li>
                                                       <a href="/account">Account Settings</a>
                                                    </li>
                                                    {
                                                        system.is_owner ? 
                                                            <li>
                                                                <a href="/account/payment-settings">Payment Settings</a>
                                                            </li>
                                                        : null
                                                    }
                                                    
                                                </ul>
                                            </div>
                                            <div className='app-header--profile-actions-panel'>
                                                <ul>
                                                    <li>
                                                        {/* eslint-disable-next-line */}
                                                        <a href="#" onClick={onLogout}>Log out</a>
                                                    </li>
                                                </ul>
                                            </div>
                                           
                                        </div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                    <div className='app-content'>
                        <Switch>
                            {nav.map((navItem)=>{
                                return <Route key={navItem.path} {...navItem}/>
                            })}
                            <Route component={TermsAndConditions} path="/terms-and-conditions"/>
                            <Route component={PrivacyPolicy} path="/privacy-policy"/>
                        </Switch>
                        <footer>
                            <ul>
                                <li>
                                    <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/terms-and-conditions">Terms and Conditions</NavLink>
                                </li>
                            </ul>
                        </footer>
                    </div>
                </div>
            </div>
        </>
    );
}